import type { ReactNode } from 'react';
import StatusBadge from './StatusBadge';

/**
 * The one DRAFT pill: shown beside any legal text that is a placeholder and not counsel's
 * (the key terms of a contract, the privacy notice, a template version). The wording defaults
 * to DRAFT; a place that needs to say more passes it.
 */
export default function DraftTag({ children = 'DRAFT' }: Readonly<{ children?: ReactNode }>): JSX.Element {
  return (
    <StatusBadge tone="warning" className="ml-2 uppercase tracking-wide">
      {children}
    </StatusBadge>
  );
}
